import styles from './ProjectModal.module.scss';
import {
  TextButton,
  TextButtonColor,
} from 'components/uikit/buttons/TextButton.tsx';
import { useScopedTranslation } from 'application/localization/useScopedTranslation.ts';
import { ProjectTab } from './ProjectModal';

type ProjectModalTitleProps = {
  isEditing: boolean;
  selectedTab: ProjectTab;
  setSelectedTab: (tab: ProjectTab) => void;
};

export const ProjectModalTitle: React.FC<ProjectModalTitleProps> = ({
  isEditing,
  selectedTab,
  setSelectedTab,
}) => {
  const i18n = useScopedTranslation('Component.ProjectModal');

  return (
    <div className={styles.modalTitle}>
      {i18n.t(isEditing ? 'edit_title' : 'create_title')}
      <div className={styles.projectTabsButtons}>
        <TextButton
          title={i18n.t('main_tab')}
          className={
            selectedTab == ProjectTab.Main
              ? styles.activeTabButton
              : styles.tabButton
          }
          color={
            selectedTab == ProjectTab.Main
              ? TextButtonColor.Primary
              : TextButtonColor.GreyPlain
          }
          onClick={() => setSelectedTab(ProjectTab.Main)}
        />
        <TextButton
          title={i18n.t('ai_context_tab')}
          className={
            selectedTab == ProjectTab.AI
              ? styles.activeTabButton
              : styles.tabButton
          }
          color={
            selectedTab == ProjectTab.AI
              ? TextButtonColor.Primary
              : TextButtonColor.GreyPlain
          }
          onClick={() => setSelectedTab(ProjectTab.AI)}
        />
      </div>
    </div>
  );
};
